import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { switchMap, takeUntil } from 'rxjs/operators';
import { BookingService } from '@beautyapp/core';
import { Subject } from 'rxjs';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AppointmentFacade } from '../../booking-modal/appointment-facade.service';
import { TextareaComponent } from '@beautyapp/form';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'beautyapp-disable-reason',
    templateUrl: './disable-reason.component.html',
    styleUrls: ['./disable-reason.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TextareaComponent,
        NzModalModule,
        NzSpaceModule,
        NzButtonModule
    ]
})
export class DisableReasonComponent implements OnInit, OnDestroy {
  modal = inject(NzModalRef);
  private appointmentFacade = inject(AppointmentFacade);
  private bookingService = inject(BookingService);

  readonly data = inject(NZ_MODAL_DATA)

  get bookingId() {
    return this.data.bookingId;
  }
  isLoading: any = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    disableReason: new UntypedFormControl(null),
  });

  sub$ = new Subject();

  ngOnInit(): void {}

  deleteBooking() {
    this.isLoading = true;
    this.appointmentFacade.isLoading.next(true);
    this.appointmentFacade
      .submit()
      .pipe(
        takeUntil(this.sub$),
        switchMap((res) =>
          this.bookingService.delete(this.bookingId, this.form.value)
        )
      )
      .subscribe((res) => {
        this.modal.triggerOk();
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }
}
